const facilityPaymentsGenerationSectionResources = {
    facilityPaymentWarningMessageFormat: 'Facility Payments have already been generated. Are you sure you want to re-generate them?',
};
export default facilityPaymentsGenerationSectionResources;
